import React from "react";
import {NavLink, useLocation} from "react-router-dom";

function Navigation() {
  const location = useLocation();
  const pathParts = location.pathname.split("/");
  if(pathParts.length>3){
  pathParts.pop()
    }
  const basePath = pathParts.join("/");
  return (
    <div className="navigation">
      <nav className="navbar navbar-expand navbar-dark bg-dark">
        <div className="container">
          <NavLink className="navbar-brand" to={`${basePath}${location.search}`}>
            React Multi-Page Website
          </NavLink>
          <div>
            <ul className="navbar-nav ml-auto">
              <li className="nav-item">
                <NavLink className="nav-link" to={`${basePath}${location.search}`}>
                  Home
                  <span className="sr-only">(current)</span>
                </NavLink>
              </li>
              <li className="nav-item">
                <NavLink className="nav-link" to={`${basePath}/about${location.search}`}>
                  About
                </NavLink>
              </li>
              <li className="nav-item">
                <NavLink className="nav-link" to={`${basePath}/contact${location.search}`}>
                  Contact
                </NavLink>
              </li>
              <li className="nav-item">
                <NavLink className="nav-link" to={`${basePath}/blog${location.search}`}>
                  Blog
                </NavLink>
              </li>
              <li className="nav-item"><button style={{'marginTop':'6px'}} id='offer-page'>Change Plan</button></li>
            </ul>
          </div>
        </div>
      </nav>
    </div>
  );
}

export default Navigation;
